import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { SelectChangeEvent } from 'primeng/types/select';
import { LocaleService } from '../../_utility';
import { Languages } from '../../_models';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss', './flags.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [Select, FormsModule],
})
export class LanguagePickerComponent implements OnInit {
  countries: any[] | undefined;

  selectedCountry: any | undefined;
  constructor(private locale: LocaleService) {}
  ngOnInit() {
    this.countries = [
      { name: 'Italiano', code: 'IT', lang: Languages.it },
      { name: 'English', code: 'UK', lang: Languages.en },
    ];
    this.selectedCountry = this.countries.find(
      (country) => country.lang === this.locale.getLanguage()
    );
  }

  changeLanguage(event: SelectChangeEvent) {
    this.locale.changeLanguage(this.selectedCountry.lang);
  }
}
